/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';

import { cn } from '@/lib/utils';

interface InputProps extends React.ComponentProps<'input'> {
  label?: string | React.ReactNode;
  required?: boolean;
  error?: any;
  touched?: boolean;
  errorClass?: string;
  labelClass?: string;
  containerClass?: string;
}

function Input({
  className,
  type,
  label,
  error,
  touched,
  required = false,
  errorClass,
  labelClass,
  containerClass,
  ...props
}: InputProps) {
  return (
    <div className={cn('w-full relative', containerClass)}>
      <div className={cn(' flex items-start gap-1', label && labelClass)}>
        {label && (
          <label
            htmlFor={props.id}
            className='mb-1 text-sm font-medium leading-[100%] tracking-[0%]'
          >
            {label}
          </label>
        )}
        {
          required && (
            <span>
              <svg
                width='6'
                height='6'
                viewBox='0 0 6 6'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M2.21732 5.72728L2.31178 3.62927L0.541892 4.76776L-1.11163e-05 3.82316L1.87925 2.86364L-1.11163e-05 1.90412L0.541892 0.959522L2.31178 2.09802L2.21732 5.24521e-06H3.29615L3.20169 2.09802L4.97158 0.959522L5.51348 1.90412L3.63422 2.86364L5.51348 3.82316L4.97158 4.76776L3.20169 3.62927L3.29615 5.72728H2.21732Z'
                  fill='#EE4545'
                />
              </svg>
            </span>
          )
          // <sup className='font-black text-sm text-[#FF3A29]'>*</sup>
        }
      </div>

      <input
        type={type}
        data-slot='input'
        className={cn(
          'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-10.5 w-full min-w-0 rounded-[0.5rem] border bg-transparent text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm py-4 px-2 text-foreground focus-visible:outline-none focus-visible:border-primary focus-visible:ring-1 focus-visible:ring-offset-1 focus-visible:ring-[#6A5BF966]',
          // 'aria-invalid:border-destructive aria-invalid:focus-visible:ring-destructive text-sm',
          error && touched && 'border-[#DC2B2B] focus-visible:ring-[#F95B5B66] focus-visible:border-[#DC2B2B]',
          className
        )}
        {...props}
      />

      {error && touched && (
        <span
          className={cn(
            'absolute text-[0.6875rem] text-destructive leading-[100%] tracking-tight block -bottom-[14px]',
            errorClass
          )}
        >
          {error}
        </span>
      )}
    </div>
  );
}

export { Input };
